export default "__VITE_ASSET__BIV5n_hy__"